import type { ChinaAllocation, ChinaAssetKey, ChinaMarketAssumption } from "./types";

export const chinaAssetOrder: ChinaAssetKey[] = ["equity", "fixedIncome", "alternatives", "cash"];

export const chinaAssetLabels: Record<ChinaAssetKey, string> = {
  equity: "A股权益",
  fixedIncome: "境内债券",
  alternatives: "商品及另类",
  cash: "现金及货币工具",
};

export const defaultChinaPortfolio: {
  policy: ChinaAllocation;
  current: ChinaAllocation;
  bands: ChinaAllocation;
} = {
  policy: { equity: 45, fixedIncome: 35, alternatives: 10, cash: 10 },
  current: { equity: 45, fixedIncome: 35, alternatives: 10, cash: 10 },
  bands: { equity: 5, fixedIncome: 5, alternatives: 3, cash: 3 },
};

export const verifiedChinaMarketAssumptions: ChinaMarketAssumption[] = [
  {
    asset: "equity",
    label: "A股权益",
    benchmark: "沪深300指数（000300）",
    expectedReturn: 9.02,
    volatility: 17.38,
    yield: 2.11,
    returnMethod: "官方单张披露的3年年化历史收益；不是未来收益预测",
    volatilityMethod: "官方单张披露的3年年化历史波动率",
    asOf: "2026-06-30",
    sourceName: "中证指数有限公司",
    sourceUrl: "https://oss-ch.csindex.com.cn/static/html/csindex/public/uploads/indices/detail/files/zh_CN/000300factsheet.pdf",
  },
  {
    asset: "fixedIncome",
    label: "境内债券",
    benchmark: "中证全债指数（H11001）",
    expectedReturn: 4.91,
    volatility: 1.41,
    yield: 1.86,
    returnMethod: "官方单张披露的3年年化历史收益；不是到期收益承诺",
    volatilityMethod: "官方单张披露的3年年化历史波动率",
    asOf: "2026-01-30",
    sourceName: "中证指数有限公司",
    sourceUrl: "https://oss-ch.csindex.com.cn/static/html/csindex/public/uploads/indices/detail/files/zh_CN/H11001factsheet.pdf",
  },
  {
    asset: "alternatives",
    label: "商品及另类",
    benchmark: "中证商品期货趋势配置策略指数（930666）",
    expectedReturn: 8.78,
    volatility: 10,
    returnMethod: "官方单张披露的3年年化历史收益；不是未来收益预测",
    volatilityMethod: "官方单张披露的5年年化历史波动率；官方3年指标为空",
    asOf: "2026-05-29",
    sourceName: "中证指数有限公司",
    sourceUrl: "https://oss-ch.csindex.com.cn/static/html/csindex/public/uploads/indices/detail/files/zh_CN/930666factsheet.pdf",
    secondarySourceUrl: "https://www.sge.com.cn/sjzx/shanghaiAuAuto",
  },
  {
    asset: "cash",
    label: "现金及货币工具",
    benchmark: "1年期中债国债收益率 / 中证货币基金指数",
    expectedReturn: 1.1441,
    volatility: 0.08,
    yield: 1.1441,
    returnMethod: "1年期中债国债收益率作为人民币无风险利率代理",
    volatilityMethod: "中证货币基金指数3年年化历史波动率",
    asOf: "2026-07-17",
    sourceName: "中央结算公司 / 中证指数",
    sourceUrl: "https://yield.chinabond.com.cn/cbweb-pbc-web/pbc/more?locale=cn_ZH",
    secondarySourceUrl: "https://oss-ch.csindex.com.cn/static/html/csindex/public/uploads/indices/detail/files/zh_CN/H11025factsheet.pdf",
  },
];

export const chinaYieldCurve = [
  { tenor: "1年", government: 1.1441, aaaCredit: 1.5194 },
  { tenor: "3年", government: 1.2887, aaaCredit: 1.6493 },
  { tenor: "5年", government: 1.4466, aaaCredit: 1.7825 },
  { tenor: "7年", government: 1.5683, aaaCredit: 1.9405 },
  { tenor: "10年", government: 1.7404, aaaCredit: 2.1134 },
  { tenor: "30年", government: 2.2425, aaaCredit: null },
] as const;

export const chinaYieldCurveAsOf = "2026-07-17";
